/* Component Dependencies */
var reservationInformationFormTemplate = require('templates/reservationInformationForm.hbs');
var AriesComponent = require('libs/aries-component');
var ResponsiveUtils = require('utils/responsiveUtils');
var DateHandler = require('libs/date-handler');
var $ = require('jquery');

AriesComponent.create({
  type: 'reservationInformation',

  template: {
    'reservationInformationForm': reservationInformationFormTemplate
  },

  events: {
    'click .js-toggle-picker': 'toggleDatePicker'
  },

  subscribe: {
    'TOGGLE_VISIBLE_RES_INFO': 'toggleVisible'
  },

  bindEvents: function () {
    var _self = this;
    window.$(_self.$el.find('input')[0].form).on('reset', _self.onFormRest.bind(_self));
    this.initDateHandler();
  },

  onFormRest: function() {
    this.$el.find('input').each(function(index, input) {
      $(input).attr('value', '');
      input.value = "";
      input.readOnly = false;
    });
  },

  initDateHandler: function() {
    var _self = this;
    _self.pickadates = {};
    _self.$el.find('.js-datepick-container').each(function(_, node) {
        var dateHandler = new DateHandler({
            $el: _self.$el.find(node),
            $parent: _self,
            singleDate: true
        });
        dateHandler.init();
        _self.pickadates[dateHandler.from.$input.attr('id')] = dateHandler.from.$input.data('pickadate');
        $(dateHandler.from.$input[0]).data('pickadate', dateHandler.from.$input.data('pickadate'));
    });
  },

  toggleDatePicker: function(evt) {
    evt.preventDefault();
    evt.stopImmediatePropagation();
    var $input = $(evt.target).parent().find('.picker__input');
    var pickadate = $input.data('pickadate');
    if( $input.hasClass('picker__input--active') ) {
      pickadate.close();
      $(evt.target).removeClass('t-icon-arrow-up');
    } else {
      pickadate.open();
      $(evt.target).addClass('t-icon-arrow-up');
    }
  },

  toggleVisible: function(data) {
    var visible = data.visible,
      selectedTopic = data.selectedTopic,
      topicAboutAStayTemplate = this.$el.data('topics'),
      $optionalText = this.$el.find('.js-optional-text');

    $optionalText.addClass('is-hidden');
    visible ? this.$el.removeClass('is-hidden') : this.$el.addClass('is-hidden'); 
    
    if (visible && window.event != undefined) {
      this.$el.find('input').val('');
    }
    
    if (topicAboutAStayTemplate.includes(selectedTopic)) {
      $optionalText.removeClass('is-hidden');
    } else {
      $optionalText.addClass('is-hidden');
    }
      
  }
});
